export default {
  user: {},
  userData: {},
  loginAction: "",
  signinWith: "",
  selectedUser: {},
  getUserByUserId: {},
  sessionPrice: {},
  userRole: "",
  getUser: {},
};
